
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 230 230"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M230 115C227.42 268.35 2.56 268.32 0 115c2.58-153.34 227.44-153.32 230 0z","fill":"#2aadad"}}),_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M143 81.7c-17.23-10.56-41.75-2.59-52.59 16.6-12.25 21.7-11.16 39.3-37.47 48.46 31.62 2.47 42-19 47.39-28.2 4.47-7.66 11.1-14.31 19.84-14.31 6.69 0 10.22 2.67 11.11 3.33 3.34 2.5 5.11 7.67 4.42 11.82-1 6.14-7.07 11.59-14.83 11.37-6.48-.2-11.07-7.13-12.49-11.29a14.46 14.46 0 00-.84 4.32c-.84 8.37 5.15 18.85 16.35 20.84 8.9 1.57 19.31.31 26.56-6.22a30.94 30.94 0 007.34-10c6.65-17.13 3.75-35.34-14.79-46.72z","fill":"#fff","data-name":"Layer 2-2"}})])])])
          )
        }
      }
    